var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorAlert',[_vm._v(" It looks like you're running an old version of the app. Please wait for the new version to be installed or reload. ")])}
var staticRenderFns = []

export { render, staticRenderFns }